module.exports = __webpack_public_path__ + "static/the_times-6b29c36fdd9db62a94eeacd384e62478.svg";